<template>
    <div>
        <mt-header title="續保提示"></mt-header>
        <h2 style="color: black;padding: 10px;">{{this.toDate*1000 | date('%Y-%m-%d')}} - 續保提示</h2>
        <div v-for="(renewal,index) in renewalNoticeList" style="padding: 10px;">
            <div> <span style="color: red;">{{renewal.clientName}}</span> 的保單於
                <span style="color:red;">{{renewal.nextPremiumDate*1000 | date('%Y-%m-%d') }}</span>到期繳交保費.
            </div>
        </div>
        <div style="padding: 10px;">
            <span>以上為 <span style="color: red;">{{renewalNoticeList.length}}</span> 份續保提示, 請查看</span>
            <div style="margin-top: 10px;">謝謝!</div>
        </div>
    </div>
</template>

<script>
    import "mint-ui/lib/style.css";
    import { Header } from 'mint-ui';
    import {queryRenewalNotice} from '../../api/api'

    export default {
        data() {
            //驗證登錄名字
            return {
                policy:{
                    policyNo:'Test'
                },
                renewalNoticeList:[],
                partnerId:null,
                toDate:null
            }
        },
        methods: {
            queryRenewalNoticeList(){
                if (this.partnerId&&this.toDate){
                    let params={partnerId:this.partnerId,date:this.toDate}
                    return queryRenewalNotice(params).then(res=>{
                        if(res.errcode==200){
                            this.renewalNoticeList=res.data;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryRenewalNotice Error");
                    });
                }else{
                    this.renewalNoticeList=[];
                }
            },

        },
        mounted() {
            this.partnerId=this.$route.query.partnerId;
            this.toDate=this.$route.query.toDate;
            this.queryRenewalNoticeList();
        },
        computed: {

        },
        activated(){

        }
    }

</script>

<style lang="scss" scoped>
    .right{
        float: right;
    }
    .el-tag + .el-tag {
        margin-left: 1px;
        margin-top: 1px;
    }
</style>




// WEBPACK FOOTER //
// src/views/wechat/RenewalNotice.vue